var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechBiosimilar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.2,387.6c-20.3,0-36.8-16.5-36.8-36.8s16.5-36.8,36.8-36.8s36.8,16.5,36.8,36.8S224.5,387.6,204.2,387.6 z M204.2,332.6c-10,0-18.2,8.2-18.2,18.2s8.2,18.2,18.2,18.2s18.2-8.2,18.2-18.2S214.2,332.6,204.2,332.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305,350.8c-25.3,0-45.8,20.6-45.8,45.8c0,25.3,20.6,45.8,45.8,45.8c25.3,0,45.8-20.5,45.8-45.8 C350.8,371.3,330.2,350.8,305,350.8z M305,424.1c-15.2,0-27.5-12.3-27.5-27.5c0-15.2,12.3-27.5,27.5-27.5 c15.2,0,27.5,12.3,27.5,27.5C332.5,411.8,320.1,424.1,305,424.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "neutral_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.3,130.9H176.7c-5.1,0-9.2-4.1-9.2-9.2V85.1c0-5.1,4.1-9.2,9.2-9.2h146.6c5.1,0,9.2,4.1,9.2,9.2v36.6 C332.5,126.8,328.4,130.9,323.3,130.9z M185.9,112.5h128.3V94.2H185.9V112.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.5,479.1H145.5c-27.3,0-78.8-12.8-78.8-61.4c0-33.2,38.5-92.2,85-160.2c15.4-22.6,32.9-48.1,34.2-54 l-0.1-81.7c0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2v82.5c0,8.3-9.1,22.3-37.4,63.6c-32.6,47.6-81.8,119.6-81.8,149.9 c0,42.4,58,43.1,60.5,43.1h208.9c2.5,0,60.5-0.7,60.5-43.1c0-30.3-49.2-102.3-81.8-149.9c-28.2-41.3-37.4-55.3-37.4-63.6v-82.5 c0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2v82.5c1.2,5.1,18.7,30.7,34.2,53.3c46.5,68,85,127,85,160.2 C433.3,466.2,381.7,479.1,354.5,479.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,222.5c-20.2,0-36.7-16.4-36.7-36.7s16.4-36.7,36.7-36.7s36.7,16.4,36.7,36.7S270.2,222.5,250,222.5z  M250,167.5c-10.1,0-18.3,8.2-18.3,18.3c0,10.1,8.2,18.3,18.3,18.3c10.1,0,18.3-8.2,18.3-18.3C268.3,175.7,260.1,167.5,250,167.5 z M277.5,94.2c-20.2,0-36.7-16.4-36.7-36.7s16.4-36.7,36.7-36.7s36.7,16.4,36.7,36.7S297.7,94.2,277.5,94.2z M277.5,39.3 c-10.1,0-18.3,8.2-18.3,18.3s8.2,18.3,18.3,18.3c10.1,0,18.3-8.2,18.3-18.3S287.6,39.3,277.5,39.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_group_x3E__1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.8,295.8H149.2c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2h201.6c5.1,0,9.2,4.1,9.2,9.2 S355.9,295.8,350.8,295.8z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechBiosimilar2;